import PropTypes from "prop-types"
import React from "react"

const InputField = (props) => {
    const {
        type,
        name,
        value,
        placeholder,
        onChange,
        label,
        id,
        maxLength,
        disabled,
        required,
        checked,
        inputRef
    } = props

    return type !== "checkbox" ? (
        <div className="relative form-input">
            <input
                type={ type }
                id={ id }
                name={ name }
                className="block w-full p-2 text-sm text-gray-900 
                bg-transparent rounded-lg border border-lightGray 
                appearance-none focus:outline-none focus:ring-0 focus:border-primary-100 peer focus:bg-lightSkyblue"
                placeholder={ placeholder }
                maxLength={ maxLength }
                value={ value }
                onChange={ onChange }
                disabled={ disabled }
                ref={ inputRef }
            />
            <label
                htmlFor={ name }
                className="
        absolute bg-white dark:bg-darkCard text-sm  duration-300 transform -translate-y-[20px] 
        scale-75 top-[10px] z-[1] origin-[0] start-2.5 peer-focus:text-blue-600 
        peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 
        peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-[20px] 
        left-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto"
            >
                { required && <span className="text-red text-sm">*</span> } { label }
            </label>
        </div>
    ) : (
        <>
            <input
                type={ type }
                id={ id }
                name={ name }
                className="appearance-none relative h-[18px] w-[18px] 
                border border-gray-300 rounded-[4px] checked:bg-primary-50 
                checked:border-primary-50 focus:outline-none "
                defaultChecked={ value }
                onChange={ onChange }
                disabled={ disabled }
                checked={ checked }
                
            />  
            <style>{
                ` input[type="checkbox"]:checked::before { 
                content: ''; 
                position: absolute; 
                width: 6px; 
                height: 12px; 
                border-right: 2px solid white; 
                border-bottom: 2px solid white; 
                transform: rotate(45deg); 
                top: 0px; 
                left: 5px; } `
            }
            </style> 
        </>
    )
}

InputField.propTypes = {
    checked: PropTypes.bool,
    disabled: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    inputRef: PropTypes.object,
    label: PropTypes.string.isRequired,
    maxLength: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    required: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
}

export default InputField
